type WebUploadOptions = {
  authToken: string
  baseUrl?: string
  type: string
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null

export async function uploadToWebStorage(file: File, opts: WebUploadOptions): Promise<string> {
  const base = (opts.baseUrl || '').trim().replace(/\/$/, '')
  const url = `${base}/api/web/upload`

  const form = new FormData()
  form.append('type', opts.type)
  form.append('file', file)

  const res = await fetch(url, {
    method: 'POST',
    headers: { Authorization: `Bearer ${opts.authToken}` },
    body: form
  })

  const data: unknown = await res.json().catch(() => null)
  if (!res.ok) {
    const msg =
      (isRecord(data) && typeof data.message === 'string' && data.message.trim() ? data.message.trim() : null) ||
      (isRecord(data) && typeof data.error === 'string' && data.error.trim() ? data.error.trim() : null) ||
      `Upload failed (${res.status})`
    throw new Error(msg)
  }

  if (!isRecord(data)) throw new Error('Upload failed: invalid server response')
  const rawUrl = data.url
  if (typeof rawUrl !== 'string' || !rawUrl.trim()) {
    throw new Error('Upload failed: missing file URL')
  }
  return rawUrl.trim()
}

